/**
 * 统一URL管理
 * @author fe-account
 * @Date 2017-05-24
 */
import getURL from '../../okjp/constants/URL';

const OKEX_BASE_URL2 = `${window.location.protocol}//${window.location.host}`;
const USER_CENTER_PATH = '/v3/users';

const MOCK_URL = '/rap/app/mock/14';
const BASE_URL =
  process.env.NODE_ENV === 'development' ? OKEX_BASE_URL2 : OKEX_BASE_URL2;

const siteURL = getURL({
  BASE_URL,
  MOCK_URL,
  OKEX_BASE_URL2,
  USER_CENTER_PATH,
});

/*
 * URL统一管理
 */
const URL = {
  // 用户中心
  USER_CAPTCHA: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/common/captcha`,
  USER_LOGIN: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/login?loginName={0}`,
  USER_REGISTER_EMAIL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/register/email`,
  USER_CONFIRM_ACCOUNT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/reset-confirm-account`,
  USER_RESET_LOGIN_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/reset-login-pwd`,
  USER_CHECK_NAME: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/register/check-regname`,
  USER_PROFILE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/profile`,
  USER_ASP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/asp`,
  USER_GO_BUSINESS_VERIFY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/go-business-verify`, // 子账户  是否开启各项验证
  USER_PHONE_CODE_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/support/phone-code-list`,
  USER_SECURITY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/index`,
  GET_COUNTRY_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/location/country`,
  GET_REGION_STATE_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/location/state`,
  GET_LOGIN_QR_CODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/qrcode`,
  GET_LOGIN_QR_CODE_STATUS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/qrcode-status`,
  GET_THIRD_BIND_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/third/getBindList`,

  // ThirdPart Login & Register
  THIRD_PART_BIND_EMAIL_FIRST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/thirdpart/bindEmail/first`,
  THIRD_PART_BIND_EMAIL_SECOND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/thirdpart/bindEmail/second`,
  THIRD_PART_BIND_EMAIL_FINAL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/thirdpart/bindEmail/final`,
  USER_REGISTER_THIRD_PARTY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/thirdpart/register`,
  POST_THIRD_TO_BIND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/third/to-bind`,
  THIRD_PART_LOGIN_BIND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/third/bind`,
  THIRD_PART_LOGIN_TO_UNBIND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/third/to-unbind`,
  THIRD_PART_LOGIN_UNBIND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/third/unbind`,

  // 条款管理
  USER_CLAUSE_WITHDRAW_TERM_LINK: `${OKEX_BASE_URL2}/v3/users/terms/withdraw-term-link`,
  USER_ADD_LOGIN_PWD_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/add-login-pwd-go`,
  USER_ADD_LOGIN_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/add-login-pwd`,

  USER_ADD_TRADE_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/add-trade-pwd`,
  USER_ADD_TRADE_PWD_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/add-trade-pwd-go`,

  USER_ADD_PASSKEY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/passkey/add`,
  USER_ADD_PASSKEY_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/passkey/add-go`,
  USER_MANAGE_PASSKEY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/passkey/manage`,
  USER_MANAGE_PASSKEY_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/passkey/manage-go`,

  // Passkey V3 - Registration
  PASSKEY_REG_START: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/registration/start`,
  PASSKEY_REG_FINISH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/registration/finish`,

  // Passkey V3 - Login
  PASSKEY_LOGIN_START: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/login/start`,
  PASSKEY_LOGIN_FINISH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/login/finish`,

  // Passkey V3 - Management
  PASSKEY_MGT_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/list`,
  PASSKEY_REMOVE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/remove`,
  PASSKEY_RENAME: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/rename`,
  PASSKEY_VERIFICATION_TOGGLE_INIT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/verification-toggle/init`,
  PASSKEY_VERIFICATION_TOGGLE_SWITCH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/verification-toggle/switch`,
  PASSKEY_MFA_INIT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/mgt/mfa/init`,

  // Passkey V3 - Reset
  PASSKEY_RESET_REBIND_START: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/reset/rebind/start`,
  PASSKEY_RESET_REBIND_FINISH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/passkey/reset/rebind/finish`,

  // MFA Module
  MFA_CREATE_SESSION: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/create-session`,
  MFA_START: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/start`,
  MFA_PASSKEY_START: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/passkey/start`,
  MFA_PASSKEY_FINISH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/passkey/finish`,
  MFA_VERIFY_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/verify-pwd`,
  MFA_VERIFY_OTP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/verify-otp`,
  MFA_SEND_CODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/send-code`,
  MFA_SWITCH_STEP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/mfa-module/switch-step`,

  USER_MODIFY_LOGIN_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/modify-login-pwd`,
  USER_MODIFY_LOGIN_PWD_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/modify-login-pwd-go`,

  USER_MODIFY_TRADE_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/modify-trade-pwd`,
  USER_MODIFY_TRADE_PWD_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/modify-trade-pwd-go`,

  USER_RESET_TRADE_PWD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/reset-trade-pwd`,
  USER_RESET_TRADE_PWD_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/reset-trade-pwd-go`,

  USER_ADD_PHONE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/phone/add`,
  USER_ADD_PHONE_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/phone/add-go`,

  USER_MODIFY_PHONE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/phone/update`,
  USER_MODIFY_PHONE_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/phone/update-go`,

  USER_SWITCH_PHONE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/phone/validate-switch`,

  // 日本站二次验证
  USER_VERIFY_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/verify/switch-go`,
  USER_VERIFY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/verify/switch`,

  USER_GOOGLE_KEY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/gcode/googlekey-apply`,
  USER_GOOGLE_BIND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/gcode/gcode-auth-bind`,
  USER_GOOGLE_RESET: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/gcode/gcode-auth-reset`,

  USER_ADD_EMAIL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/bind`,
  USER_ADD_EMAIL_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/bind-go`,
  USER_RESET_EMAIL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/reset`,
  USER_RESET_EMAIL_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/reset-go`,
  USER_ACTIVATE_EMAIL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/activate`,
  USER_ACTIVATE_EMAIL_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/activate-go`,

  USER_EMAIL_VERIFY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/email/set-email-verify`,

  USER_SWITCH_FREQUENCY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/tradepwd-frequency-switch`,
  USER_SWITCH_FREQUENCY_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/tradepwd-frequency-close-go`,

  USER_EMAIL_RECEIVE_SETTING: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/email-receive-setting`,
  USER_EMAIL_RECEIVE_SETTING_GO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/pwd/email-receive-setting-go`,

  USER_SWITCH_LOGIN_GOOGLE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/gcode/login-validate-switch`,
  USER_SWITCH_TRADE_GOOGLE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/security/gcode/trade-validate-switch`,

  USER_MY_APL_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/apisecret/list`,
  USER_MY_APL_CREATE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/apisecret/create`,
  USER_MY_APL_DELETE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/apisecret/delete`,
  USER_MY_APL_UPDATE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/apisecret/update`,
  USER_MY_APL_DETAIL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/apisecret/detail`,

  SEND_EMAIL_CODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend-auth/email-sendcode`,
  SEND_PHONE_CODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend-auth/phone-sendcode`,
  SEND_PHONE_VOICE_CODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend-auth/phone-voice-msg`,

  SEND_EMAIL_CODE_NO_AUTH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend/email-sendcode`,
  SEND_PHONE_CODE_NO_AUTH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend/phone-sendcode`,
  SEND_VOICE_CODE_NO_AUTH: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgsend/phone-voice-msg`,

  // 个人中心
  // 资金管理
  GET_ACCOUNT_AMOUNT: `${OKEX_BASE_URL2}/v2/asset/accounts/user-currency-balance`,
  GET_CURRENCIES_LIST: `${OKEX_BASE_URL2}/v2/asset/transaction/public/currencies`,
  GET_CURRENCIES_LIST_V2: `${OKEX_BASE_URL2}/v2/asset/currency/detail/currencies`,
  GET_PRODUCT_LIST: `${OKEX_BASE_URL2}/v2/markets/products`,
  GET_MARGIN_BALANCE: `${OKEX_BASE_URL2}/v2/margin/accounts`,
  GET_ACCOUNTS_RECEIVE: `${OKEX_BASE_URL2}/v2/asset/accounts/receive`,
  POST_ACCOUNTS_RECEIVE: `${OKEX_BASE_URL2}/v2/asset/accounts/receive`,
  GET_ACCOUNTS_SWITCH: `${OKEX_BASE_URL2}/v2/spot/accounts/fork/switch`,
  GET_INSIDERCOIN_LIST: `${OKEX_BASE_URL2}/v2/spot/accounts/insiderCoinList`,
  POST_ACCOUNTS_MERGE: `${OKEX_BASE_URL2}/v2/spot/accounts/merge`,
  POST_ACCOUNTS_FORK: `${OKEX_BASE_URL2}/v2/spot/accounts/fork`,
  GET_ASSET_CURRENCY: `${OKEX_BASE_URL2}/v2/asset/accounts/currencies`,

  POST_EMAIL_CODE: `${OKEX_BASE_URL2}/v2/asset/withdraw/sendEmailCode`,

  GET_WITHDRAW_AMOUNT: `${OKEX_BASE_URL2}/v2/asset/withdraw/v2`,
  GET_WITHDRAW_LIST: `${OKEX_BASE_URL2}/v2/asset/withdraw/list`,
  CANCEL_WITHDRAW: `${OKEX_BASE_URL2}/v2/asset/withdraw/cancel`,
  GET_WITHDRAW_REASON_LIST: `${OKEX_BASE_URL2}/v2/asset/withdraw/withdrawReasonList`,
  GET_WITHDRAW_TARGET_CONFIG: `${OKEX_BASE_URL2}/v2/asset/withdraw/withdrawTargetConfigV2`,

  GET_CHECK_IP: `${OKEX_BASE_URL2}/v2/spot/black/checkIp`,
  GET_CHECK_IP_NOT_LOGIN: `${OKEX_BASE_URL2}/v2/spot/black/not-login-checkIp`,

  ADD_ADDRESS: `${OKEX_BASE_URL2}/v2/asset/withdraw/add-address`,

  GET_DEPOSIT_LIST: `${OKEX_BASE_URL2}/v2/asset/deposit/list`,
  FILL_SENDER_INFO: `${OKEX_BASE_URL2}/v2/asset/deposit/fillSenderInfo`,
  GET_DEPOSIT_ADDRESS: `${OKEX_BASE_URL2}/v2/asset/deposit`,
  GET_DEPOSIT_HISTORY_ADDRESS: `${OKEX_BASE_URL2}/v2/asset/deposit/address`,

  GET_BILL_TYPE: `${OKEX_BASE_URL2}/v2/asset/accounts/bill-types`,
  GET_TIPSBILL_TYPE: `${OKEX_BASE_URL2}/v2/asset/financial/bill-types`,
  GET_BILLS: `${OKEX_BASE_URL2}/v2/asset/accounts/bills`,
  GET_TIPSBILLS: `${OKEX_BASE_URL2}/v2/asset/financial/bills`,
  GET_TIPSCURRENCY: `${OKEX_BASE_URL2}/v2/asset/financial/currency`,
  GET_SPOT_CURRENCY_BALANCE: `${OKEX_BASE_URL2}/v2/spot/accounts/by-currency?currencyId={0}`,
  GET_SPOT_MAX_AVAILABLE: `${OKEX_BASE_URL2}/priapi/v5/spot-legacy/max-available`,

  SEND_PHONE_MSG: `${OKEX_BASE_URL2}/v2/asset/withdraw/sendMsg`,

  GET_WITHDRAW_MAX_BALANCE: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw/calc-max?availableBalance={0}`,
  POST_USD_WITHDRAW: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw`,
  GET_JP_WITHDRAW_HISTORY: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw/history`,
  GET_JP_DEPOSIT_HISTORY: `${OKEX_BASE_URL2}/v2/asset/cash/deposit/history`,
  GET_JP_DEPOSIT: `${OKEX_BASE_URL2}/v2/asset/cash/deposit`,
  GET_JP_DEPOSIT_BIND_ONETIME_BANK: `${OKEX_BASE_URL2}/v2/fiat/deposit/bind-onetime-bank`,
  GET_JP_DEPOSIT_CHECK_ONETIME_BANK: `${OKEX_BASE_URL2}/v2/fiat/deposit/check-onetime-bank`,
  GET_JP_DEPOSIT_CONFIG: `${OKEX_BASE_URL2}/v2/fiat/global/config`,
  GET_JP_WITHDRAW_CANCEL: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw/cancel`,
  GET_JP_WITHDRAW_DETAIL: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw`,
  GET_BIND_BANK: `${OKEX_BASE_URL2}/v2/fiat/global/config`,
  GET_JP_WITHDRAW_CODE: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw/sendMsg`,
  GET_JP_BANKCARD_CODE: `${OKEX_BASE_URL2}/v2/fiat/cash/bankcard/sendMsg`,
  GET_JP_WITHDRAW_EMAIL: `${OKEX_BASE_URL2}/v2/asset/cash/withdraw/sendEmailCode`,
  GET_JP_BANKCARD_EMAIL: `${OKEX_BASE_URL2}/v2/fiat/cash/bankcard/sendEmailCode`,

  // 钱包账户
  GET_ACCOUNT_ANALYSIS: `${OKEX_BASE_URL2}/v2/asset/accounts/analysis`,
  GET_ACCOUNT_VALUATION: `${OKEX_BASE_URL2}/v2/asset/accounts/valuation`,
  GET_ACCOUNT_VALUATIONMULTI: `${OKEX_BASE_URL2}/v2/asset/accounts/valuation-multi`,

  // 日本站 添加银行卡
  GET_BANK_LIST: `${OKEX_BASE_URL2}/v2/fiat/cash/bank-card`,
  POST_BIND_CARD: `${OKEX_BASE_URL2}/v2/fiat/cash/bind-bank-card`,
  POST_UPDATE_CARD: `${OKEX_BASE_URL2}/v2/fiat/cash/update-bank-card`,
  GET_USER_CARD: `${OKEX_BASE_URL2}/v2/fiat/cash/bind-card-list`,
  POST_DELETE_JPCARD: `${OKEX_BASE_URL2}/v2/fiat/cash/unbind-card`,

  // kyc认证
  GET_KYC_INFOS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/infos`,

  GET_KYC_UPLOAD_CONFIG: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/clientUploadImageAuth`, // 向服务器申请授权上传文件
  GET_KYC_UPLOAD_CALLBACK: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/callbackForClientUploadImage`, // 向服务器拿回OSS图片信息
  GET_KYC_UPLOAD_OCR_CALLBACK: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/callbackForClientUploadImageOCR`, // 向服务器拿回OSS图片信息-OCR

  GET_KYC_COUNTRYLIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/support/kycCountries`,
  GET_KYC_PROVINCELIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/support/province/{0}`,
  GET_KYC_GETFACEURL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/getUserKycFaceUrl`,
  GET_KYC_KYCLIMITS: `${OKEX_BASE_URL2}/v3/c2c/configs/kycLimits`,
  GET_KYC_CURRENT: `${OKEX_BASE_URL2}/v3/c2c/accounts/current`,

  GET_KYC_ENTERPRISESAMPLE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/sample-file`,

  // 日本kyc
  GET_KYC_INIT_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/init-info`,
  GET_KYC_INIT_INFO_V2_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/init-info`,
  GET_KYC_INIT_INFO_V2: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/init-info`,
  GET_REKYC_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/rekyc/info`,
  UPDATE_REKYC_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/rekyc/change`,
  POST_KYC_SAVE_GUARDIAN: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/person/save-guardian`,
  GET_KYC_GUARDIAN: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/person/info-guardian`,
  GET_KYC_ADDRESSLIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/support/addressList`,
  GET_KYC_FILE_UPLOAD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/file-upload`,
  GET_INQUIRY_FILE_UPLOAD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/inquiry-file-upload`,
  GET_BANK_CARD_FILE_URL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/bank-card/image-url/{0}`,
  GET_BANK_CARD_FILE_UPLOAD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/bank-card/file-upload`,
  GET_BANK_CARD_DEFAULT_NAME: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/bank-card/default-name`,
  GET_KYC_SAVE_FIRST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/savePersonalInfo`,
  GET_KYC_SAVE_FIRST_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/saveCorporateInfo`,
  GET_KYC_INFO_FIRST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/person/info-first`,
  GET_KYC_INFO_FIRST_PERSON: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/echoPersonalInfo`,
  GET_KYC_INFO_FIRST_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/echoCorporateInfo`,
  GET_KYC_SAVE_SECOND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/saveFileInfo`,
  GET_KYC_INFO_SECOND: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/echoFileInfo`,
  GET_KYC_SAVE_SECOND_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/saveFileInfo`,
  GET_KYC_INFO_SECOND_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/echoFileInfo`,
  GET_KYC_SAVE_THIRD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/savePurpose`,
  GET_KYC_INFO_THIRD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/v2/person/echoPurpose`,
  GET_KYC_SAVE_THIRD_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/savePurpose`,
  GET_KYC_INFO_THIRD_CORP: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/echoPurpose`,
  GET_KYC_SUBMIT_AUDIT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/submit-audit`,
  GET_KYC_DICTIONARY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/dictionary`, // 获取字典信息
  GET_KYC_COMPANY_INFO_FIRST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/company/info-first`,

  // ekyc特别增加的接口
  GET_EKYC_CONFIG: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/ekyc/getEkycConfig`,
  CHECK_EKYC_STATUS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/ekyc/checkEkycStatus`,
  GET_EKYC_QRCODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/ekyc/getQId`,
  CHECK_EKYC_QRCODE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/ekyc/checkQId`,

  // 地址校验
  GET_KYC_ADDRESS_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/address-info`,
  GET_KYC_SUBMIT_ADDRESS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/submit-address`,

  // CARF 届出書提交
  GET_CARF_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/carf/info`,
  GET_CARF_DICT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/carf/dict`,
  POST_CARF_SUBMIT: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/carf/submit`,
  GET_CARF_KYCINFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/carf/getKycInfoForCarf`,

  // 我的等级
  GET_FEE_USER_LEVEL: `${OKEX_BASE_URL2}/v2/spot/user-level`,
  GET_FEE_ASSET_LEVEL: `${OKEX_BASE_URL2}/v3/users/fee/volume/level/detail`,
  GET_FEE_TRADE_ACCOUNT_LEVEL: `${OKEX_BASE_URL2}/v3/users/fee/volume/level/detail`,
  GET_FEE_LEVEL_ALL_LIST: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/fee/level/all`,
  GET_FEE_WITHDRAW: `${OKEX_BASE_URL2}/v2/asset/withdraw`,
  GET_FEE_WITHDRAW_MAX_BALANCE: `${OKEX_BASE_URL2}/v2/asset/withdraw/calc-max?currencyId={0}&availableBalance={1}`,

  // 重构接口
  // 资金管理
  SUB_CURRENCY_LIST: `${OKEX_BASE_URL2}/v2/asset/accounts/currencies`,
  // 检查用户是否充值 提现接口
  CHECK_DEPOSIT_LIST: `${OKEX_BASE_URL2}/v2/asset/deposit/user-check`,
  CHECK_WITHDRAW_LIST: `${OKEX_BASE_URL2}/v2/asset/withdraw/user-check`,
  GET_WITHDRAW_ADDRESS_LIST: `${OKEX_BASE_URL2}/v2/asset/withdraw/address-by-type/v2`,
  GET_WITHDRAW_TARGET_LIST: `${OKEX_BASE_URL2}/v2/asset/withdraw/target`,
  GET_WITHDRAW_CHECK_ADDRESS: `${OKEX_BASE_URL2}/v2/asset/withdraw/address-verify`,
  WITHDRAW_CHECK: `${OKEX_BASE_URL2}/v2/asset/withdraw/withdraw-check`,
  POST_WITHDRAW_CONFIRM: `${OKEX_BASE_URL2}/v2/asset/withdraw/extract`,
  POST_WITHDRAW_ADDRESS_DELETE: `${OKEX_BASE_URL2}/v2/asset/withdraw/address-delete`,

  // 我的资产
  ASSETS_OVERVIEW: `${OKEX_BASE_URL2}/v2/asset/accounts/asset-overview`,
  ASSETS_VALUATION_UNIT: `${OKEX_BASE_URL2}/v2/asset/accounts/valuation-unit`,
  BALANCE_KYC_LIMIT: `${OKEX_BASE_URL2}/v2/asset/withdraw/level-limit`,

  // 报表列表
  REPORT_LIST: `${OKEX_BASE_URL2}/v2/asset/report/list`, // 获取报表列表
  REPORT_DOWNLOAD: `${OKEX_BASE_URL2}/v2/asset/report/download`, // 获取报表下载数据

  // 取引履歴csv
  RECORD_LIST: `${OKEX_BASE_URL2}/v2/asset/record/list`,
  RECORD_CREATE: `${OKEX_BASE_URL2}/v2/asset/record/create`,
  RECORD_DOWNLOAD: `${OKEX_BASE_URL2}/v2/asset/record/download`,

  // 通信制御機能
  GET_EMAIL_SETTINGS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgControl/getUserEmailSetting`,
  SAVE_EMAIL_SETTINGS: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/msgControl/saveUserEmailSetting`,

  // 赚币
  GET_EARN_USER_BALANCE: `${OKEX_BASE_URL2}/v2/asset/earn/balance`,
  GET_EARN_USER_HISTORY_ORDERS: `${OKEX_BASE_URL2}/v2/asset/earn/historyOrders`,
  GET_EARN_USER_ACTIVE_ORDERS: `${OKEX_BASE_URL2}/v2/asset/earn/activeOrders`,
  GET_EARN_USER_BILL: `${OKEX_BASE_URL2}/v2/asset/earn/bills`,
  GET_EARN_REDEEM_RULE: `${OKEX_BASE_URL2}/v2/asset/earn/redeemRule`,
  POST_EARN_REDEEM: `${OKEX_BASE_URL2}/v2/asset/earn/redeem`,
  GET_EARN_CHANGEABLE_PROJECTS: `${OKEX_BASE_URL2}/v2/asset/earn/changeableProjects`,
  GET_EARN_CHANGE_RULE: `${OKEX_BASE_URL2}/v2/asset/earn/changeRule`,
  POST_EARN_CHANGE: `${OKEX_BASE_URL2}/v2/asset/earn/change`,
  GET_EARN_CURRENCIES: `${OKEX_BASE_URL2}/v2/asset/earn/public/currencies`,
  GET_EARN_USER_HAS_UNCHECKED_FAILED_BILLS: `${OKEX_BASE_URL2}/v2/asset/earn/hasUncheckedFailedBills`,

  // 资产分析
  GET_ANALYSIS_ASSET: '/v2/asset/analysis', // 资产分析 用户资产总览
  GET_ANALYSIS_TREND: '/v2/asset/analysis/trend', // 资产分析 获取折线图数据
  GET_ANALYSIS_CURRENCY_ASSETS: '/v2/asset/analysis/currencyList', // 获取资产走势时币种下拉列表
  GET_ASSETS_TREND: '/v2/asset/analysis/assetsTrend', // 资产走势

  // OOL-7937
  GET_HANDLE_CONFIG: `${OKEX_BASE_URL2}/v2/asset/balance/handle-config`,
  GET_FREEZE_RECORDS: `${OKEX_BASE_URL2}/v2/asset/balance/get-freeze-records`,
  DO_FREEZE: `${OKEX_BASE_URL2}/v2/asset/balance/freeze`,
  DO_UNFREEZE: `${OKEX_BASE_URL2}/v2/asset/balance/unfreeze`,

  // OOL-8393
  BIND_CARD_GO: `${OKEX_BASE_URL2}/v2/fiat/cash/bind-bank-card-go`,
  UPDATE_CARD_GO: `${OKEX_BASE_URL2}/v2/fiat/cash/update-bank-card-go`,

  // OOL- 8743
  PLT_TO_APT_CONFIG: '/v2/asset/currency/conversion/config',
  PLT_TO_APT_SUBMIT: '/v2/asset/currency/conversion/submit',

  // OOL-8907
  GET_BILL_TYPES: `/v2/earn/public/billTypes`,
  ...siteURL,

  // KYC重构接口
  GET_KYC_INFO: `${OKEX_BASE_URL2}/v3/users/kyc/info`,
  GET_SHAREHOLDER_TEMPLATE: `${OKEX_BASE_URL2}/v3/users/kyc/shareholder/template`,
  GET_SHAREHOLDER_LIST: `${OKEX_BASE_URL2}/v3/users/kyc/shareholder/list`,
  ADD_SHAREHOLDER: `${OKEX_BASE_URL2}/v3/users/kyc/shareholder/add`,
  UPDATE_SHAREHOLDER: `${OKEX_BASE_URL2}/v3/users/kyc/shareholder/{compositeId}/update`,
  DELETE_SHAREHOLDER: `${OKEX_BASE_URL2}/v3/users/kyc/shareholder/{compositeId}/delete`,
  SAVE_KYC_INFO: `${OKEX_BASE_URL2}/v3/users/kyc/saveInfo`,
  POST_KYC_SUBMIT_AUDIT: `${OKEX_BASE_URL2}/v3/users/kyc/submit-audit`,
  GET_KYC_OPTIONS_ALL: `${OKEX_BASE_URL2}/v3/users/kyc/options/all`,
  GET_KYC_OPTIONS_SINGLE: `${OKEX_BASE_URL2}/v3/users/kyc/options/{0}`,
  POST_KYC_SWITCH_METHOD: `${OKEX_BASE_URL2}/v3/users/kyc/switchMethod`,

  // OOL-11379 phishing freeze / restriction unlock
  FISHING_UNLOCK_CURRENCY_DICT: `${OKEX_BASE_URL2}/v3/users/phishing/unlock/currency/dict`,
  FISHING_UNLOCK_SCENE_DICT: `${OKEX_BASE_URL2}/v3/users/phishing/unlock/scene/dict`,
  FISHING_UNLOCK_DETAILS: `${OKEX_BASE_URL2}/v3/users/phishing/unlock/details`,
  FISHING_UNLOCK_CONFIRM: `${OKEX_BASE_URL2}/v3/users/phishing/unlock/confirm`,
  FISHING_UNLOCK_PROTECT: `${OKEX_BASE_URL2}/v3/users/phishing/unlock/protect`,
};
export default URL;
